import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { ErrorTableRow } from './ErrorTableRow';
import questionMark from '../../../images/QuestionMark.png';

export const ErrorTable = ({ data }) => {
  const tooltipText = '';

  return (
    <React.Fragment>
      <Row className="error-table-row">
        <Col xs={2} className="error-table-header error-table-border">
          <b>Line #
            <img
              alt="question mark"
              className="question-mark d-print-none ml-1"
              src={questionMark}
              data-tip={tooltipText}
              data-for={'tooltip'}
              data-effect="solid"
              data-multiline={true}
              data-type="light"
              data-border
            />
          </b>
          <ReactTooltip id="tooltip" getContent={() =>
            <span>
              Line numbers include the header row but exclude any blank row.<br />
              If your line numbers are off, make sure you remove blank lines from the import file.
            </span>} />
        </Col>
        <Col xs={10} className="error-table-header error-table-border">
          <b>Error Message</b>
        </Col>
      </Row>
      {data.map(r => r.didError ? <ErrorTableRow key={r.lineNumber} lineNumber={r.lineNumber} exception={r.exception} /> : null)}
    </React.Fragment>
  );
}

export default ErrorTable;
